import type { DashboardWidgetConfiguration } from './widget-definition';

export const organisationSummaryRolePoliciesWidget: DashboardWidgetConfiguration = {
  widgetId: "organisation.summary.role.policies",
  name: "Role policies",
  description: "Current canonical owner-authorised record count, not a dated transaction total.",
  apps: [
    "configuration",
  ],
  template: "record-metric",
  query: {
    kind: "context",
    input: "value",
  },
  inputs: {
    label: "Role policies",
    value: null,
    description: "Current authorised record",
  },
  dummyData: {
    value: "—",
  },
  limits: {
    minWidth: 3,
    maxWidth: 12,
    minHeight: 1,
    maxHeight: 1,
    defaultWidth: 3,
    defaultHeight: 1,
  },
};
